export const DEFAULT_START_TIME = '07:30';
export const DEFAULT_END_TIME = '23:00';

export const DEFAULT_SLEEP_SETTINGS = [
  {
    day: 1,
    start: DEFAULT_START_TIME,
    end: DEFAULT_END_TIME,
  },
  {
    day: 2,
    start: DEFAULT_START_TIME,
    end: DEFAULT_END_TIME,
  },
  {
    day: 3,
    start: DEFAULT_START_TIME,
    end: DEFAULT_END_TIME,
  },
  {
    day: 4,
    start: DEFAULT_START_TIME,
    end: DEFAULT_END_TIME,
  },
  {
    day: 5,
    start: DEFAULT_START_TIME,
    end: DEFAULT_END_TIME,
  },
  {
    day: 6,
    start: DEFAULT_START_TIME,
    end: DEFAULT_END_TIME,
  },
  {
    day: 7,
    start: DEFAULT_START_TIME,
    end: DEFAULT_END_TIME,
  },
];
